var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.recipientSearchResultContainer] = true, _class[_vm.$style.selected] = _vm.selected, _class[_vm.$style.disabled] = _vm.disabled, _class),
    on: {
      "click": function click($event) {
        return _vm.selectRecipient({
          recipientId: _vm.recipient.id
        });
      }
    }
  }, [_c('div', [_vm.recipient.recipientType === 'user' ? [_c('div', {
    class: _vm.$style.userInfoContainer
  }, [_vm.recipient.photoUrl ? _c('img', {
    class: _vm.$style.userPhoto,
    attrs: {
      "src": _vm.recipient.photoUrl,
      "alt": ""
    }
  }) : _c('img', {
    class: _vm.$style.userPhoto,
    attrs: {
      "src": _vm.defaultPicture,
      "alt": ""
    }
  }), _c('div', {
    class: _vm.$style.userInfo
  }, [_c('h4', {
    staticClass: "color-primary-blue font-weight-bold"
  }, [_vm._v(_vm._s(_vm.recipient.name))]), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(_vm._s(_vm.getTradename))]), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(_vm._s(_vm.getAddress))])])])] : [_c('div', {
    class: _vm.$style.officeInfoContainer
  }, [_c('div', {
    class: _vm.$style.officeInfo
  }, [_c('h4', {
    staticClass: "color-primary-blue font-weight-bold"
  }, [_vm._v("Motto Mortgage " + _vm._s(_vm.recipient.tradeName))]), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(_vm._s(_vm.recipient.primaryOwnerName))]), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(" " + _vm._s(_vm.getAddress) + " ")])])])]], 2), _vm._t("actionButton")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }